import ChargeInventoryListView from "../../components/ChargeInventoryListView";

ChargeInventoryListScreen.propTypes = {};

function ChargeInventoryListScreen(props) {
    return (
        <div className="container-fluid px-4 my-4">
            <ChargeInventoryListView />
        </div>
    );
}

export default ChargeInventoryListScreen;
